export const sessionStorageKeys = {
    utmStorageKey: 'utm_params',
};

export const localStorageKeys = {
    storedHeaderKey: 'header',
    storageVersionKey: 'storageVersion',
};
